import { render, staticRenderFns } from "./m-loader.vue?vue&type=template&id=0dcca1fe"
import script from "./m-loader.vue?vue&type=script&lang=js"
export * from "./m-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports